import { compact } from 'lodash';
import { useMemo } from 'react';

import { Diagnosis } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { VisitStatusResolver } from '~legacy.patient';

type DiagnosisSidePanelContentDataAccessorProps = {
   readonly diagnosis: Diagnosis[];
};

export const DiagnosisSidePanelContentDataAccessor = (
   props: DiagnosisSidePanelContentDataAccessorProps
): JSX.Element => {
   const visitIds = useMemo<number[]>(() => {
      return compact(props.diagnosis.map((diagnosis) => diagnosis.visitId?.asNumber()));
   }, [props.diagnosis]);

   return <VisitStatusResolver visitIds={visitIds} />;
};
